export class Product {
  $key: string;
  index?: number;
  productId: number;
  productName: string;
  productCategory: string;
  productPrice: number;
  productDescription: string;
  productImageUrl?: string;
  productQuantity?: number;
  new?: number;
  sale?: boolean;
  dinerName?: string;
  remark?: string;
  toppings?: optionGroup[];
  subItems?: optionGroup[];
  totalPrice?: number;

}

export class optionGroup {
  $key: string;
  optionsGroupName: string;
  minOptions: number;
  maxOptions: number;
  options: Product[];
}
